import React from "react";

import { ArrowDownIcon, ArrowRightIcon } from "../utils/components/icons";

class ToggleMenu extends React.Component {
  state = {
    showMenuPoint: false,
  };

  toggleHandler = () => {
    const doesShow = this.state.showMenuPoint;
    this.setState({ showMenuPoint: !doesShow });
  };

  render() {
    //ToggleFunktion
    let collapsibleMenuPoint = null;
    if (this.state.showMenuPoint) {
      collapsibleMenuPoint = this.props.children;
    }

    //Add-button
    let button = null;
    if (this.props.hasButton) {
      button = this.props.button;
    }

    const arrow = this.state.showMenuPoint
      ? (
        <ArrowDownIcon
          className={this.props.hasMargin ? "ms-one-half" : null}
          onClick={this.toggleHandler}
        ></ArrowDownIcon>
      )
      : (
        <ArrowRightIcon
          className={this.props.hasMargin ? "ms-one-half" : null}
          onClick={this.toggleHandler}
        ></ArrowRightIcon>
      );

    return (
      <div className="mb-1 d-flex w-100 flex-wrap">
        <button
          type="button"
          className="btn btn-default align-middle mb-0 text-start flex-grow-1"
          onClick={this.toggleHandler}
        >
          {arrow}
          <span className="sectionTitle ms-one-half w-100 me-one">
            {this.props.name}
          </span>
        </button>
        {button}
        <div className="w-100">
          {collapsibleMenuPoint}
        </div>
      </div>
    );
  }
}

export default ToggleMenu;
